<template>
<div>
    <div class="form-group">
        <h4 class="animated slideInDown">
            <fa-icon icon="satellite-dish" style="margin-top:-3px"/> Monitoramento
            <fa-icon icon="arrow-left" class="animated slideInRight float-right" v-if="cliente.id != null" style="margin-top:4px; cursor:pointer" @click="$emit('limpa-cliente')" /> 
        </h4>
    </div>

    <div v-for="(item, index) in clientes" :key="index">
        <div v-if="item.equipamentos.length > 0">
            <div class="item-background animated fadeInUp fast" 
                    :class="{'item-open': cliente.id != null ? cliente.id == item.id : false}" 
                    v-if="cliente.id != null ? cliente.id == item.id : true" 
                    @click.prevent="$emit('seta-cliente', item)" 
                    style="cursor:pointer;padding:0.4em">
                {{item.nome}}

                <span class="float-right badge badge-light" style="font-size:1em">{{item.equipamentos.length}}</span>
            </div>

            <div style="margin-top:8px">

                <div v-show="cliente.id != null ? cliente.id == item.id : false"
                    class="subitem-background animated fadeInUp" 
                    :class="{'subitem-selected' : equip._selecionado}" 
                    @click.prevent="$emit('equipamento', equip)" 
                    style="padding: 0.4em 0.4em 0.4em 1em; border:1px solid #F0F0F0; cursor:pointer"  v-for="(equip, idxEquip) in item.equipamentos" :key="idxEquip">
                        <fa-icon v-if="equip._selecionado" icon="map-marker-alt" /> 
                        {{equip.prefixo}} - {{equip.imei}} 
                        <fa-icon v-if="equip._selecionado" class="float-right" style="margin-top:3px" icon="arrow-right" />
                </div>

            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        clientes: {
            type: Array,
            required: true,
            default: () => { return [] },
        },

        cliente: {
            type: Object,
            required: true,
            default: {},
        }
    },

    
}
</script>




// WEBPACK FOOTER //
// src/views/monitoramento/lista-aeronaves.vue